module.exports = __webpack_public_path__ + "media/images/cms/img_slide_12-f04268b483e391e9bdb7800b18dc3425.jpg";